import { createFeatureSelector } from '@ngrx/store';
import { User } from '../../lib/classes/user';

export const selectCurrentUser = createFeatureSelector<{ currentUser: User }>(
  'currentUser'
);
